import * as React from 'react';

import { CarouselFullscreen } from '../../../../CarouselFullscreen';

import * as aboutAdvance from './aboutAdvance.module.scss';
import * as licenses from '../../../../Licenses/licenses.module.scss';

import licensesData from './licenses.json';

export const AboutAdvance = ({
  data = { licensesData },
  sectionClassName,
  container,
  titleClassName,
  textClassName,
}) => {
  const [fullScreenState, setFullScreenState] = React.useState({ open: false, selectedSlideIndex: 0 });

  return (
    <section className={sectionClassName || aboutAdvance.aboutAdvance}>
      <div className={container || 'container'}>
        <h2 className={titleClassName || aboutAdvance.aboutAdvance__title}>Центр образовательных технологий Advance</h2>
        <div className="row">
          <div className="col-12 col-md-6">
            <p className={textClassName || aboutAdvance.aboutAdvance__text}>
              Мы&nbsp;— частная образовательная организация с&nbsp;курсами для детей и&nbsp;взрослых. В&nbsp;наших
              программах применяются авторские методики развития когнитивных навыков: памяти, внимания, интеллектуальной
              выносливости, навыка самостоятельного обучения. Иными словами, наши курсы помогают эффективнее учиться
              и&nbsp;работать и&nbsp;делать это с&nbsp;удовольствием.
            </p>
            <p className={textClassName || aboutAdvance.aboutAdvance__text}>
              С 2009 года наши курсы прошли 85&nbsp;тысяч человек. Мы знаем, как сделать так, чтобы студент не бросал
              учёбу, а дошёл до конца.
            </p>
            <p className={textClassName || aboutAdvance.aboutAdvance__text}>
              Мы разработали специальную образовательную платформу, которая помогает учащимся пройти курс.
            </p>
          </div>
          <div className={`col-12 col-md-6 ${aboutAdvance.aboutAdvance__wrap}`}>
            <div className={aboutAdvance.aboutAdvance__licenses}>
              {licensesData.map((elem, index) => (
                <div className="col" key={index}>
                  <button
                    className={licenses.licenses__imgBlock}
                    onClick={() => {
                      setFullScreenState({ open: true, selectedSlideIndex: index });
                    }}
                  >
                    <span className={licenses.licenses__zoomIn}></span>
                    <img src={elem.imageSrc} alt={elem.title} className={licenses.licenses__img} />
                  </button>
                </div>
              ))}
            </div>
            <p
              className={
                textClassName || `${aboutAdvance.aboutAdvance__text} ${aboutAdvance.aboutAdvance__textLicenses}`
              }
            >
              Лицензии Advance на&nbsp;осуществление образовательной деятельности
            </p>
          </div>
        </div>
      </div>

      <CarouselFullscreen
        data={licensesData.map((elem) => (
          <img className={licenses.licenses__imgFullScreen} src={elem.imageSrc} alt={elem.title} />
        ))}
        open={fullScreenState.open}
        selectedSlideIndex={fullScreenState.selectedSlideIndex}
        onClose={() => {
          setFullScreenState({ open: false, selectedSlideIndex: 0 });
        }}
      />
    </section>
  );
};
